export const GET_MY_USER = 'GET_MY_USER';
export const SET_TOKEN = 'SET_TOKEN';
